import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import getColumns from './getColumns';
import TableLayout from '../shared/TableLayout';
import { selectDisplayColumnsForReports } from '../../redux/store/ui/common';
import {
  fetchReportsIfNeeded,
  selectDisplayReports,
  selectSelectedReport,
} from '../../redux/store/userData/reports';
import { fetchReports } from '../../redux/store/userData/reports/thunk';
import { getFilteredColumns } from '../../utils';
import withPaginatedQueryFetch from '../../hoc/withPaginatedQueryFetch';
import { selectReportWithUIEffect } from '../../redux/store/ui/common/thunk';

const ReportsTable = (props: any) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const displayReports = useSelector(selectDisplayReports);
  const selectedReport = useSelector(selectSelectedReport);
  const displayColumns = useSelector(selectDisplayColumnsForReports);

  const selectedId = selectedReport?.id ?? null;
  const columns = getColumns({ intl });
  const filteredColumns = getFilteredColumns(columns, displayColumns);

  const onClickRow = (record: any) => {
    dispatch(selectReportWithUIEffect(record));
  };

  const loadReports = useCallback(async () => {
    dispatch(fetchReportsIfNeeded());
  }, []);

  useEffect(() => {
    loadReports();
  }, []);

  return (
    <TableLayout
      rowKey="id"
      columns={filteredColumns}
      dataSource={displayReports}
      selectedId={selectedId}
      totalNumber={displayReports?.length!}
      onClickRow={onClickRow}
    />
  );
};

export default withPaginatedQueryFetch(ReportsTable, fetchReports);
